import React, { useContext } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, SIZE, ROLE } from 'baseui/modal';

import { ModalContext } from '../../context/modal';

const CustomModal = () => {
	const { modalConfig, setModalConfig } = useContext(ModalContext);
	const handleClose = () => {
		setModalConfig({ isOpen: false });
	};
	return (
		<Modal
			onClose={handleClose}
			closeable
			isOpen={modalConfig.isOpen}
			animate
			autoFocus
			size={SIZE.default}
			role={ROLE.dialog}
			overrides={{
				Dialog: {
					style: {
						height: 'auto',
						width: 'auto'
					}
				}
			}}>
			<ModalHeader>{modalConfig.header}</ModalHeader>
			<ModalBody>{modalConfig.content}</ModalBody>
			<ModalFooter>{modalConfig.footer}</ModalFooter>
		</Modal>
	);
};

export default CustomModal;
